interface RedditEvidenceCardProps {
  title: string | null;
  url: string | null;
  metadata: Record<string, unknown>;
}

function formatNumber({ value }: { value: number }): string {
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1).replace(/\.0$/, "")}k`;
  }
  return String(value);
}

export function RedditEvidenceCard({
  title,
  url,
  metadata,
}: RedditEvidenceCardProps) {
  const commentCount =
    typeof metadata.commentCount === "number" ? metadata.commentCount : null;
  const subreddit =
    typeof metadata.subreddit === "string" ? metadata.subreddit : null;

  const inner = (
    <div className="space-y-1.5">
      <div className="flex items-center gap-2">
        <div className="flex size-5 shrink-0 items-center justify-center rounded-full bg-[#ff4500]">
          <svg
            aria-hidden="true"
            className="size-3.5 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M15.8 4.8c-.7 0-1.3.3-1.7.8-1.5-1-3.4-1.7-5.4-1.8l1-4.5 3.2.7c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6S15.4 0 14.5 0c-.6 0-1.2.4-1.4.9L9.6 0c-.2 0-.3.1-.3.3l-1.1 5c-2.1.1-4 .8-5.5 1.8-.4-.5-1-.8-1.7-.8C.5 6.3 0 6.8 0 7.4c0 .4.2.8.6 1-.1.3-.1.6-.1 1C.5 12.5 4.6 15 9.5 15s9-2.5 9-5.6c0-.3 0-.7-.1-1 .3-.3.6-.6.6-1 0-.7-.5-1.2-1.2-1.6zM5 9.6c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6c-.9 0-1.6-.7-1.6-1.6zm7.6 3.4c-.9.9-2.7 1-3.1 1-.4 0-2.2-.1-3.1-1-.2-.2-.2-.4 0-.6.2-.2.4-.2.6 0 .6.6 1.7.8 2.5.8s1.9-.2 2.5-.8c.2-.2.4-.2.6 0 .2.2.2.5 0 .6zm-.2-1.8c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6z" />
          </svg>
        </div>
        <span className="font-semibold text-[0.7rem] text-[var(--explore-text-muted)] uppercase tracking-[0.06em]">
          {subreddit ? `r/${subreddit}` : "Reddit"}
        </span>
      </div>

      {title && (
        <p className="font-medium text-[0.88rem] text-[var(--explore-text-primary)] leading-snug">
          {title}
        </p>
      )}

      {commentCount !== null && (
        <p className="text-[0.75rem] text-[var(--explore-text-muted)]">
          {formatNumber({ value: commentCount })} comments
        </p>
      )}
    </div>
  );

  const cardClasses =
    "mb-5 block rounded-xl border border-[var(--explore-border)] bg-[var(--explore-bg-card)] px-4 py-3 no-underline transition-colors hover:border-[var(--explore-text-muted)]";

  if (url) {
    return (
      <a
        className={cardClasses}
        href={url}
        rel="noreferrer noopener"
        target="_blank"
      >
        {inner}
      </a>
    );
  }

  return <div className={cardClasses}>{inner}</div>;
}
